var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "valor_abono",
                  vMoney: "",
                  format: _vm.money,
                  placeholder: "Escriba un valor..."
                },
                model: {
                  value: _vm.form.valor,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "valor", $$v)
                  },
                  expression: "form.valor"
                }
              },
              [
                _vm._v("\n          $ Valor\n          "),
                _vm.errores.valor
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.valor[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "descripcion",
                  placeholder: "Seleccione...",
                  id: "bodega_id",
                  options: _vm.bodegas
                },
                on: { input: _vm.inputBodega },
                model: {
                  value: _vm.selectedBodega,
                  callback: function($$v) {
                    _vm.selectedBodega = $$v
                  },
                  expression: "selectedBodega"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "bodega_id" } }, [
                _vm._v("Sucursal")
              ]),
              _vm._v(" "),
              _vm.errores.bodega_id
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.bodega_id[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "textarea-field",
              {
                attrs: {
                  placeholder: "Escriba un detalle...",
                  id: "observacion"
                },
                model: {
                  value: _vm.form.detalle,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "detalle", $$v)
                  },
                  expression: "form.detalle"
                }
              },
              [
                _c("span", [_vm._v("Detalle")]),
                _vm._v(" "),
                _vm.errores.detalle
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.detalle[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "descripcion",
                  placeholder: "Seleccione...",
                  id: "tipo_movimiento_id",
                  options: _vm.tiposMovimiento
                },
                on: { input: _vm.inputTipoMovimiento },
                model: {
                  value: _vm.selectedTipoMovimiento,
                  callback: function($$v) {
                    _vm.selectedTipoMovimiento = $$v
                  },
                  expression: "selectedTipoMovimiento"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_movimiento_id" } }, [
                _vm._v("Tipo de movimiento")
              ]),
              _vm._v(" "),
              _vm.errores.tipo_movimiento_id
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.tipo_movimiento_id[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.selectedTipoMovimiento != null &&
                _vm.selectedTipoMovimiento.tipo_aplicacion !== "V",
              expression:
                "selectedTipoMovimiento != null && selectedTipoMovimiento.tipo_aplicacion !== 'V'"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    placeholder: "Seleccione...",
                    options: _vm.personas,
                    id: "persona",
                    name: "persona",
                    label: "nombre"
                  },
                  on: { input: _vm.inputPersona, search: _vm.searchPersonas },
                  model: {
                    value: _vm.selectedPersona,
                    callback: function($$v) {
                      _vm.selectedPersona = $$v
                    },
                    expression: "selectedPersona"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "persona" } }, [
                  _vm._v("Personas")
                ]),
                _vm._v(" "),
                _vm.errores.persona_id
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.persona_id[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.selectedTipoMovimiento != null &&
                _vm.selectedTipoMovimiento.tipo_aplicacion === "V",
              expression:
                "selectedTipoMovimiento != null && selectedTipoMovimiento.tipo_aplicacion === 'V'"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.vendedores,
                    placeholder: "Seleccione...",
                    label: "descripcion",
                    id: "vendedor"
                  },
                  on: {
                    search: _vm.searchVendedores,
                    input: _vm.inputVendedor
                  },
                  model: {
                    value: _vm.selectedVendedor,
                    callback: function($$v) {
                      _vm.selectedVendedor = $$v
                    },
                    expression: "selectedVendedor"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "vendedor" } }, [
                  _vm._v("Vendedor")
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field" },
            [
              _c("VueCtkDateTimePicker", {
                attrs: {
                  id: "fecha",
                  locale: "es",
                  "no-label": "",
                  "button-now-translation": "Ahora",
                  format: "YYYY-MM-DD HH:mm:ss",
                  formatted: "YYYY-MM-DD HH:mm:ss",
                  label: "Seleccione fecha..."
                },
                model: {
                  value: _vm.form.fecha,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "fecha", $$v)
                  },
                  expression: "form.fecha"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha")])
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Movimiento de Nómina")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-061ffe26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061ffe26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/Movimiento.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-061ffe26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/Movimiento.vue
// module chunks = 0